export default __webpack_public_path__ + "static/media/418.6206db02.jpg";